<div class="form-floating">
  <select class="form-select PG{{Pflegegruppe}}"
          id="Pflegegruppe"
          [(ngModel)]="Pflegegruppe" (ngModelChange)="onStatusChange($event)">
    <option *ngFor="let item of Data" [ngValue]="item.key" class="PG{{item.key}}">
      {{ item.Bezeichnung }}
    </option>
  </select>
  <label for="Pflegegruppe">Pflegegruppe</label>
</div>
